import { useState } from 'react';
import { cn } from '@/libs/utils';
import usePhotoUrl from './usePhotoUrl';

/**
 * Round photo of a person. Without a photo (none stored, still loading, or a
 * broken link) it shows `fallback` — pass the initials avatar there, or leave
 * it out to render nothing at all.
 *
 * @param {Object} props
 * @param {string} [props.photoKey] - S3 key of the photo.
 * @param {number} [props.size=24] - Diameter in px.
 * @param {string} [props.alt]
 * @param {string} [props.className]
 * @param {React.ReactNode} [props.fallback=null]
 */
export default function PersonPhoto({
  photoKey,
  size = 24,
  alt = '',
  className,
  fallback = null,
}) {
  const url = usePhotoUrl(photoKey);
  const [failedUrl, setFailedUrl] = useState(null);

  if (!url || failedUrl === url) return fallback;

  return (
    <img
      src={url}
      alt={alt}
      title={alt || undefined}
      width={size}
      height={size}
      loading="lazy"
      draggable={false}
      onError={() => setFailedUrl(url)}
      style={{ width: size, height: size }}
      className={cn('block shrink-0 rounded-full object-cover', className)}
    />
  );
}
